import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  return (
    <div className={`${isVisible ? 'page-transition-active' : 'page-transition'}`}>
      <div className="bg-[#EFEAE7] min-h-screen py-16">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl">
          {/* Our Concept Section */}
          <section className="mb-24">
            <h2 className="mb-8">
              <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-3xl md:text-4xl font-bold">OUR</span>
              <br />
              <span className="font-['Playfair_Display_SC'] text-black text-3xl md:text-4xl font-bold">CONCEPT</span>
          </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <p className="font-['Outfit'] text-base md:text-lg mb-8 leading-relaxed">
                  Lotus Story offers a relaxed yet refined dining experience, catering to guests who appreciate both 
                  authenticity and innovation. Our casual tasting menus allow diners to explore a variety of flavors in a 
                  comfortable setting, making each visit a unique gastronomic adventure.
              </p>
                <p className="font-['Outfit'] text-base md:text-lg leading-relaxed">
                  We prioritize the use of fresh, locally sourced ingredients to ensure the highest quality and sustainability in every 
                  dish.
              </p>
              </div>
              <div className="flex gap-4">
                <div className="flex-1">
                  <img src="/newimages/newfood.jpg" alt="Vietnamese cuisine" className="w-full h-96 object-cover rounded-lg" />
                </div>
                <div className="flex flex-col gap-4 w-1/2">
                  <img src="/newimages/newfood2.jpg" alt="Vietnamese dishes" className="w-full h-[11.25rem] object-cover rounded-lg" />
                  <img src="/newimages/newfood3.jpg" alt="Traditional Vietnamese food" className="w-full h-[11.25rem] object-cover rounded-lg" />
                </div>
              </div>
            </div>
          </section>

          {/* The Menu Section */}
          <section className="mb-24">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div className="flex flex-col gap-4">
                <img 
                  src="/restau2.JPG" 
                  alt="Vietnamese cuisine dishes" 
                  className="w-full h-48 object-cover rounded-2xl"
                />
                <img 
                  src="/restau1.JPG" 
                  alt="Traditional Vietnamese cooking" 
                  className="w-full h-48 object-cover rounded-2xl"
                />
              </div>
              <div className="flex flex-col items-start">
                <h2 className="mb-8 self-end">
                  <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-3xl md:text-4xl font-bold">THE</span>
                  <span className="font-['Playfair_Display_SC'] text-black text-3xl md:text-4xl font-bold ml-2">MENU</span>
                </h2>
                <p className="font-['Outfit'] text-base md:text-lg leading-relaxed mb-8 text-right self-end">
                  Our menu is thoughtfully curated to showcase the diversity of Vietnamese flavors while incorporating contemporary 
                  Australian influences. We offer a variety of tasting menus, each inspired by Vietnam's unique regions, seasonal festivals, 
                  and traditional folk tales.
                </p>
                <Link 
                  to="/menu" 
                  className="inline-block px-8 py-3 border border-[#4F6632] text-[#4F6632] rounded-full font-['Outfit'] hover:bg-[#4F6632] hover:text-white transition-colors self-end"
                >
                  View Menu
                </Link>
          </div>
        </div>
      </section>

          {/* Our Story Section */}
          <section>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <h2 className="mb-8">
                  <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-3xl md:text-4xl font-bold">OUR</span>
                  <span className="font-['Playfair_Display_SC'] text-black text-3xl md:text-4xl font-bold ml-2">STORY</span>
              </h2>
                <p className="font-['Outfit'] text-base md:text-lg mb-8 leading-relaxed">
                  Lotus Story was born from a passion for Vietnamese culture, history, and cuisine. Our mission is to elevate 
                  traditional Vietnamese dishes while preserving their authenticity. Inspired by regional specialties, age-old 
                  legends, and the vibrant spirit of Vietnamese festivals, every dish at Lotus Story is crafted with love, precision, 
                  and creativity.
                </p>
                <p className="font-['Outfit'] text-base md:text-lg leading-relaxed">
                  Our vision is to become a leading brand in Vietnamese cuisine, setting new standards for quality, taste, and 
                  service. We aim to create a warm and welcoming space where customers can not only savor exceptional food 
                  but also immerse themselves in the cultural richness of Vietnam.
                </p>
              </div>
              <div className="relative h-full">
                <div className="flex gap-4">
                  <div className="flex flex-col gap-4 w-1/2">
                    <img src="/newimages/newfood4.jpg" alt="Vietnamese culinary art" className="w-full h-[11.25rem] object-cover rounded-lg" />
                    <img src="/newimages/newfood.jpg" alt="Authentic Vietnamese flavors" className="w-full h-[11.25rem] object-cover rounded-lg" />
                  </div>
                  <div className="flex-1">
                    <img src="/newimages/newfood5.jpg" alt="Vietnamese cuisine showcase" className="w-full h-96 object-cover rounded-lg" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About; 